module.exports = __webpack_public_path__ + "assets/img/huodai.7af6aef3.png";